import React from 'react';
import { Button, IconShield, Modal } from 'gatorcomponents';
import useLocale from '@/hooks/useLocale';
import { useResize } from '@/hooks/useResize';
import monarxShieldUrl from '@/media/gatorProtect/monarx-shield.png';
import * as Styles from './GatorProtectDetectedThreadsModal.styles';

const MOBILE_BREAKPOINT = 425;

const GatorProtectDetectedThreadsModal = ({
  onClose,
  onPrimary,
  threatCount,
}) => {
  const { width } = useResize();
  const isMobile = width <= MOBILE_BREAKPOINT;
  const { gatorProtect: gatorProtectLocale } = useLocale();

  if (!gatorProtectLocale?.detectedThreadsModal) {
    return null;
  }
  const { detectedThreadsModal } = gatorProtectLocale;

  return (
    <Modal
      onClose={onClose}
      maxWidth={isMobile ? '100%' : 800}
      mobileMaxHeight={360}
      noHeader
      testId="gator-protect-detected-threads-modal"
    >
      <Styles.Root $isMobile={isMobile} data-testid="gator-protect-detected-threads-modal__content">
        <Styles.BrandRow $isMobile={isMobile}>
          <Styles.ShieldWrap $isMobile={isMobile}>
            <img src={monarxShieldUrl} alt={detectedThreadsModal.shieldImageAlt} />
          </Styles.ShieldWrap>
          <Styles.BrandTextCol>
            <Styles.ProductTitle $isMobile={isMobile}>{detectedThreadsModal.productTitle}</Styles.ProductTitle>
            <Styles.ProductSubtitle $isMobile={isMobile}>{detectedThreadsModal.productSubtitle}</Styles.ProductSubtitle>
          </Styles.BrandTextCol>
        </Styles.BrandRow>

        <Styles.MessageBlock $isMobile={isMobile}>
          <Styles.Headline $isMobile={isMobile}>{detectedThreadsModal.headline}</Styles.Headline>
          <Styles.BodyText $isMobile={isMobile}>
            {detectedThreadsModal.bodyPrefix}
            <strong>{detectedThreadsModal.threatsBold({ count: threatCount })}</strong>
            {detectedThreadsModal.bodySuffixLine1}
            <br aria-hidden="true" />
            {` ${detectedThreadsModal.bodyLine2}`}
          </Styles.BodyText>
        </Styles.MessageBlock>

        <Styles.PrimaryButtonWrap>
          <Button
            label={detectedThreadsModal.primaryCta}
            onClick={onPrimary}
            size="large"
            variant="primary"
            notFillSVG
            iconLeft={<IconShield size="md" color="highPure" />}
          />
        </Styles.PrimaryButtonWrap>
      </Styles.Root>
    </Modal>
  );
};

export default GatorProtectDetectedThreadsModal;
